/**
 * Wallet permissions
 *
 * IMPORTANT: Set the numeric IDs from backend `full_permissions`.
 * We keep them as `null` until confirmed to avoid accidentally blocking access.
 */

export const WALLET_TRANSACTIONS = 1331; // reserved — for future wallet detail/show route
export const WALLET_INDEX = 1330;
export const WALLET_CHARGE = 1332;
// Permission 1333 covers both accessing the settings page and editing wallet settings.
// WALLET_EDIT is an alias used in components that need a generic "can edit" check.
export const WALLET_SETTINGS = 1333;
export const WALLET_EDIT = WALLET_SETTINGS; // alias — intentionally the same backend permission
export const WALLET_EXPORT = 1334;
export const WALLET_CARDS_INDEX = 1335; // reserved — for wallet cards list page gating
export const WALLET_CARDS_CREATE = 1336;
export const WALLET_CARDS_EDIT = 1337;
export const WALLET_CARDS_DELETE = 1338;
export const WALLET_ADMIN_ADJUST = 1339; // reserved — for admin balance adjustment panel
